import { render, staticRenderFns } from "./MoreMenuItemNSFWUserSetting.vue?vue&type=template&id=16fd6e22&scoped=true&"
import script from "./MoreMenuItemNSFWUserSetting.vue?vue&type=script&lang=ts&"
export * from "./MoreMenuItemNSFWUserSetting.vue?vue&type=script&lang=ts&"
import style0 from "./MoreMenuItemNSFWUserSetting.vue?vue&type=style&index=0&id=16fd6e22&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16fd6e22",
  null
  
)

export default component.exports